import { Component, ChangeDetectorRef } from '@angular/core';
import { ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";

@Component({
  selector: 'app-save-dialog',
  templateUrl: './save-dialog.component.html',
  styleUrls: ['./save-dialog.component.scss']
})
export class SaveDialogComponent  {
  data: any = {
    confirmMessage: 'Yes',
    declineMessage: 'No'
  };
  constructor(
    public dialogRef: ScaffoldDialogRef,
    private cdr: ChangeDetectorRef
    ) {
  }

  onYesClick(save?): void {
    this.dialogRef.close(save ? 'save':'cancel');
    //this.itemsService.routeUpdated("confirm")
    this.cdr.detectChanges();
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.cdr.detectChanges();
  }

}
